var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show == true
      ? _c("div", { staticClass: "gray" }, [
          !_vm.view
            ? _c("div", { staticClass: "dialog" }, [
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        "Add Comment to Job Order " + _vm._s(_vm.joborderid)
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "cancel",
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.comment,
                          expression: "comment"
                        }
                      ],
                      staticStyle: { width: "100%", "min-height": "30px" },
                      attrs: { id: "commentInput" },
                      domProps: { value: _vm.comment },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.comment = $event.target.value
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "buttons",
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "buttons",
                        on: {
                          click: function($event) {
                            return _vm.save()
                          }
                        }
                      },
                      [_vm._v("Add")]
                    )
                  ]
                )
              ])
            : _c("div", { staticClass: "dialog" }, [
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c("p", { staticClass: "title" }, [
                      _vm._v(
                        "Job Order " + _vm._s(_vm.joborderid) + " Comments"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "cancel",
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c("layout-1", {
                      key: _vm.commentsKey,
                      staticStyle: { height: "50vh", width: "70vw" },
                      attrs: {
                        table_name: "Comments",
                        id: _vm.pageid,
                        searchbar: false,
                        height_limit: true,
                        navbar: false,
                        select_reroute: false,
                        button_perm: "118",
                        button_name: "Delete",
                        term: "11-" + _vm.joborderid
                      },
                      on: { select: _vm.deleteComment }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "100%" } },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "buttons",
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [_vm._v("Close")]
                    )
                  ]
                )
              ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47129993", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47129993","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/comments.vue
// module id = 833
// module chunks = 0